export const getFileNameWithoutExtension = (path: string) => {
  const lastSlashIndex = path.lastIndexOf('/');
  const fileNameWithExtension = path.slice(lastSlashIndex + 1);
  const dotIndex = fileNameWithExtension.lastIndexOf('.');
  return fileNameWithExtension.slice(0, dotIndex);
};
